<script>
import { Cell, Popup, List, Picker } from 'vant'
import CheckboxCard from './CheckboxCard'
import Common from '../../tbs/model/to/Common'
import ObjectFunc from '../../tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'checkbox-list-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-list': List,
        'van-picker': Picker,
        'checkbox-card': CheckboxCard,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        value: Array,
        list: Array,
        max: Number,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: null,
            selectedList: [],
            selectedLabel: null,
            locale: new Common
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        value(value) {
            // console.log('watch value', value)
            if (value) {
                this.selectedList = ObjectFunc.cloneObject(value)
                this.calcSelectedLabel()
            }
        }
    },
    
    //--------------------------------------------------
    // component mounted
    //--------------------------------------------------
    mounted() {
        // console.log('mounted', this.value)
        if (this.value) {
            this.selectedList = ObjectFunc.cloneObject(this.value)
            this.calcSelectedLabel()
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onItemClick() {
            // console.log('onItemClick')
            this.showPopup = true
        },
        onCancelBtnClick() {
            // this.selectedList = []
            if (this.value) {
                this.selectedList = ObjectFunc.cloneObject(this.value)
                this.calcSelectedLabel()
            }
            // console.log('this.selectedList', this.selectedList)
            this.$emit('change-data', this.selectedList)
            this.showPopup = false
        },
        onConfirmBtnClick() {
            this.calcSelectedLabel()
            this.$emit('change-data', this.selectedList)
            // this.selectedList = []
            this.showPopup = false
        },
        onCheckBoxCardDataChange(data) {
            // console.log('onCheckBoxCardDataChange', data)
            if (data.opened) {
                this.selectedList.push(data.value)
            }
            else {
                const index = this.selectedList.indexOf(data.value)
                if (index > -1) {
                    this.selectedList.splice(index, 1)
                }
            }
        },
        validateSelectedRange(item) {
            // // console.log('validateSelectedRange', JSON.stringify(item), JSON.stringify(this.selectedList))
             if (this.selectedList.length == this.max) {
                 if (this.selectedList.indexOf(item.value) == -1) {
                     return true
                 }
            }
            return false
        },
        calcSelectedLabel() {
            // console.log('calcSelectedLabel', this.selectedList.length, this.list.length)
            let selectedLabels = []
            for (let i = 0; i < this.selectedList.length; i++) {
                let selectedItem = this.selectedList[i]
                for (let j = 0; j < this.list.length; j++) {
                    let item = this.list[j]
                    if (selectedItem == item.value) {
                        selectedLabels.push(item.label)
                        item.checked = true
                        break
                    }
                }
            }
            // console.log('selectedLabels', selectedLabels)
            this.selectedLabel = selectedLabels.join(this.locale['comma'])
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="checkbox-list-popup van-cell no-padding">
        <van-cell 
            class="van-cell-field"
            :title="label"
            is-link
            center
            :value="selectedLabel"
            @click="onItemClick"
        />
        <van-popup v-model="showPopup" position="bottom" @click-overlay="onCancelBtnClick">
            <div class="van-picker">
                <div class="van-picker__toolbar">
                    <button type="button" class="van-picker__cancel" @click="onCancelBtnClick">{{ locale['cancel'] }}</button>
                    <div class="van-ellipsis van-picker__title">{{ label }}</div>
                    <button type="button" class="van-picker__confirm" @click="onConfirmBtnClick">{{ locale['confirm'] }}</button>
                </div>
                <van-list class="popup-list">
                    <div v-for="item in list" :key="item.value" class="relative">
                        <checkbox-card 
                            :value="item.value"
                            :label="item.label" 
                            :subtext="item.subtext"
                            :checked="item.checked"
                            :disabled="validateSelectedRange(item)"
                            @change-data="onCheckBoxCardDataChange"
                        />
                        <div class="separator-line-bottom"/>
                    </div>
                    <div class="unsafe-area-bottom-mask"/>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>

<style scoped>
.popup-list {
    max-height: 40vh; 
    overflow-y: scroll;
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: constant(safe-area-inset-bottom);
	padding-bottom: env(safe-area-inset-bottom);
}
</style>